import { NavLink } from 'react-router';

import styles from './NavBar.module.css';

// Route table is duplicated in router.tsx; keeping it inline here avoids a
// circular import (NavBar -> router -> Layout -> NavBar). Any drift is
// caught by Pages.test.tsx which walks the same paths.
const ROUTES: ReadonlyArray<{ to: string; label: string }> = [
  { to: '/', label: 'Spectator' },
  { to: '/town', label: 'Town' },
  { to: '/inventory', label: 'Inventory' },
  { to: '/dungeons', label: 'Dungeons' },
  { to: '/settings', label: 'Settings' },
];

/**
 * Primary horizontal navigation. NavLink resolves `isActive` via the
 * matched route, and we toggle the active class accordingly. The `end`
 * prop on the Spectator link makes "/" only match the exact path so
 * non-root routes don't incorrectly highlight it.
 *
 * Phase 3 Step 6 (1/4).
 */
export function NavBar() {
  return (
    <nav className={styles.nav} aria-label="Primary navigation">
      {ROUTES.map((route) => (
        <NavLink
          key={route.to}
          to={route.to}
          end={route.to === '/'}
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.active}` : styles.link
          }
        >
          {route.label}
        </NavLink>
      ))}
    </nav>
  );
}
